import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { UserRole } from '@app/core/models';
import { AuthStoreService } from '@app/core/services/auth-store.service';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);
  const roles = (route.data['roles'] as UserRole[] | undefined) ?? [];

  return roles.length === 0 || authStore.hasAnyRole(roles)
    ? true
    : router.createUrlTree([authStore.getHomeRoute()]);
};
